import { Flex, Select, Tooltip } from 'antd';
import { useVideoContext } from '../../../hooks/use-video';
import { AspectRatio } from '@monorepo/types';
import {
  ColumnHeightOutlined,
  ColumnWidthOutlined,
  BorderOutlined,
} from '@ant-design/icons';

const { Option } = Select;

// Array of objects containing aspect ratio and corresponding icon
export const aspectRatioOptions = [
  {
    value: AspectRatio.NineBySixteen,
    label: AspectRatio.NineBySixteen,
    icon: <ColumnHeightOutlined />,
  },
  {
    value: AspectRatio.SixteenByNine,
    label: AspectRatio.SixteenByNine,
    icon: <ColumnWidthOutlined />,
  },
  {
    value: AspectRatio.OneByOne,
    label: AspectRatio.OneByOne,
    icon: <BorderOutlined />,
  },
];

const VideoPlayerSettings = () => {
  const { video, updateGeneralInfo } = useVideoContext();

  const updateAspectRatio = (aspectRatio: AspectRatio) => {
    updateGeneralInfo({ aspectRatio });
  };

  return (
    <Flex
      className="video-player-settings"
      style={{
        fontSize: '12px',
        background: '#f5f5f5',
        borderBottom: '1px solid #d9d9d9',
        padding: '10px 16px',
      }}
    >
      <Tooltip placement={'left'} title={'Aspect Ratio'}>
        <Select
          onChange={updateAspectRatio}
          style={{ width: 100 }}
          size={'middle'}
          placeholder="Select Aspect Ratio"
          value={video?.aspectRatio || AspectRatio.NineBySixteen}
        >
          {aspectRatioOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              <Flex align="center" gap={8}>
                {option.icon}
                {option.label}
              </Flex>
            </Option>
          ))}
        </Select>
      </Tooltip>
    </Flex>
  );
};

export default VideoPlayerSettings;
